import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { t } from 'ttag';
import Btn from 'components/Btn/index.js';
import Input from 'components/Input/index.js';
import { dismissLoginModal } from 'store/ducks/auth.js';
import { useAuthLoginMutation } from 'api/index.js';
import './index.scss';

const LoginModal = ({ type }) => {
    const dispatch = useDispatch();
    const [authLogin] = useAuthLoginMutation();
    const navigate = useNavigate();
    const [payload, setPayload] = useState({ username: '', password: '' });

    const FIELDS = [
        { name: 'username', value: '', label: t`(INPUT_LABEL)_USERNAME`, autoFocus: true },
        { name: 'password', value: '', label: t`(INPUT_LABEL)_PASSWORD`, type: 'password' },
    ];

    const onSubmit = e => {
        e.preventDefault();

        authLogin({ ...payload, app: type })
            .then(() => window.location.reload())
            .catch(e => e);
    };

    const onCancel = () => {
        dispatch(dismissLoginModal());
        navigate('/');
    };

    const onChange = e => setPayload({ ...payload, [e.target.name]: e.target.value });

    return (
        <div className='login-modal-wrap'>
            <form className='login-modal' onSubmit={onSubmit}>
                <h2>{t`LOGIN_MODAL_TITLE`}</h2>
                <p>{t`LOGIN_MODAL_SUBTITLE`}</p>
                {FIELDS.map((field, i) => <Input key={i} {...field} onChange={onChange} value={payload[field.name]} />)}
                <Btn type='submit' label={t`LOGIN`} />
                <Btn onClick={onCancel} variant='PLAIN' label={t`CANCEL`} />
            </form>
        </div>
    );
};

export default LoginModal;
